import useGlobalContext from "@src/globalContext/hooks/useGlobalContext";

const useUserIsLoggedIn = () => {
  const { user } = useGlobalContext();

  return user != null;
};

export default useUserIsLoggedIn;
